import React, { useState, useContext } from "react";
// Boostrap
import { Form, Button, Container, Row, Col, Image } from "react-bootstrap";
// Query
import $ from "jquery";
// React Router
import { useParams, useLocation } from "react-router-dom";
// Contexto
import { AlertBoxContext } from "../context/alertBoxContext";
// Hook form
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";


const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}


const RecuperarContraseña = ({ defaultValues, ...props }) => {


    // Alertas
    const { addAlert } = useContext(AlertBoxContext);
    // Hooks
    let query = useQuery();
    let history = useHistory();
    // Obtener token
    const token = query.get("token")
    // Form
    const [validated] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch
    } = useForm({
        defaultValues: defaultValues?.work,
    });


    // Actualizar contraseña 
    const postNuevaContraseña = (data) => {
        let settings = {
            url: `${process.env.REACT_APP_API_URL}/reset-password-action`,
            method: "POST",
            timeout: 0,
            xhrFields: {
                withCredentials: true,
            },
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            data: {
                password: data.newPassword,
                confirmPassword: data.confirmNewPassword,
                token: token,
            },
        };

        $.ajax(settings)
            .done((response) => {
                addAlert("Éxito", "Contraseña modificada correctamente", "success");
                history.push("/login")
            })
            .fail((error) => {
                addAlert("Error", "El tiempo para restaurar la contraseña ha expirado", "danger")
                history.push("/login")
            });
    }

    // On submit del formulario
    const onSubmit = (data) => {
        postNuevaContraseña(data);
    };

    return (

        <div className="login-background">
            <Container>
                <Row className="align-items-center vh-100">
                    <Col lg="3"></Col>
                    <Col lg="6">
                        <div className="d-flex justify-content-center">
                            <Image fluid src={"/images/logoSTJ.png"} alt="logo" style={{ maxHeight: "150px" }} />
                        </div>
                        <Form autoComplete="off" noValidate validated={validated} onSubmit={handleSubmit(onSubmit)} className="m-3">
                            <Form.Group>
                                <Form.Label>Nueva contraseña *</Form.Label>
                                <Form.Control
                                    name="newPassword"
                                    autoComplete="off"
                                    placeholder={"Nueva contraseña"}
                                    type="password"
                                    isInvalid={errors?.newPassword}
                                    {...register("newPassword", {
                                        required: "Este campo es obligatorio",
                                        pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[\\/?!@#$%^&*_-]).{8,}$/, message: "La nueva contraseña debe contener mayúsculas, minúsculas, números y algun carácter especial" }
                                    })} />
                                <ErrorMessage errors={errors} name="newPassword" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />

                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Confirmar contraseña *</Form.Label>
                                <Form.Control
                                    name="confirmNewPassword"
                                    autoComplete="off"
                                    placeholder={"Confirmar contraseña"}
                                    type="password"
                                    isInvalid={errors?.confirmNewPassword}
                                    {...register("confirmNewPassword", {
                                        required: "Este campo es obligatorio",
                                        pattern: { value: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[\\/?!@#$%^&*_-]).{8,}$/, message: "La nueva contraseña debe contener mayúsculas, minúsculas, números y algun carácter especial" },
                                        validate: { passwordsMatch: (confirmNewPassword) => confirmNewPassword === watch("newPassword") || "La contraseñas no coinciden" },

                                    })} />
                                <ErrorMessage errors={errors} name="confirmNewPassword" render={({ message }) => <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>} />

                            </Form.Group>
                            <Form.Group>
                                <Button type="submit" variant="outline-dark" className="btn btn-block mt-5">
                                    Guardar
                                </Button>
                            </Form.Group>
                        </Form>
                    </Col>
                    <Col lg="3"></Col>
                </Row>
            </Container>
        </div >
    )

}

export default RecuperarContraseña;